import { render, staticRenderFns } from "./SetHandlingOutTruck.vue?vue&type=template&id=5af59303&scoped=true"
import script from "./SetHandlingOutTruck.vue?vue&type=script&lang=js"
export * from "./SetHandlingOutTruck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af59303",
  null
  
)

export default component.exports